<template>
  <tab-layout :full-width="true">
    <div slot="tabContent" class="bg-white rounded mb-4 p-3">
      <page-heading>Event results</page-heading>

      <div class="prizes__title">
        <h3 class="h3 mb-3">{{ eventName }}</h3>
        <a
          href="#"
          title="Download PDF"
          class="draws__download-table prizes__pdf-icon"
          :class="{ 'draws__download--loading': downloadingPdf }"
          @click.prevent="downloadPdf"
        />
      </div>

      <div class="draws">
        <div class="draws-tabs">
          <div class="draws-tabs__header">
            <div class="draws-tabs__btn-wrap filter _prizes">
              <div
                v-for="round in rounds"
                :key="round.id"
                class="form-check pl-0 draws-tabs__btn"
                :class="{ active: activeRound === round.id }"
                @click="activeRound = round.id"
              >
                <div class="draws-tabs__btn-text form-check-label">
                  {{ round.label }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="draws-tabs__content-wrap">
          <div class="draws-tabs__content active">
            <div class="drafts-view bg-lighter border-top px-3 py-4 my-4">
              <div class="drafts-view__item mb-3">
                <span class="drafts-view__item-label">Competitors:</span>
                <span class="drafts-view__item-content">{{ activeRoundData != null ? activeRoundData.competitors : '' }}</span>
              </div>
              <div class="drafts-view__item mb-3">
                <span class="drafts-view__item-label">Paying places:</span>
                <span class="drafts-view__item-content">{{ activeRoundData != null ? activeRoundData.payingPlaces : '' }}</span>
              </div>
              <div class="drafts-view__item drafts-view__item-form mb-3 d-flex">
                <span class="drafts-view__item-label mr-1">Judges: </span>
                <span class="judge-list">{{ activeRoundData != null ? activeRoundData.judges : '' }}</span>
              </div>
            </div>

            <prizes-results-table
              :results="activeRoundData != null ? activeRoundData.results : []"
              :total-payouts="activeRoundData != null ? activeRoundData.totalPayouts : '0.00'"
            />

            <div class="cutout__container">
              <h3 class="drafts__title">Highest Cutouts</h3>
              <prizes-cutouts-table
                :cutouts="cutouts"
                :is-final-round="activeRoundData != null ? activeRoundData.isFinal : false"
                @make-winner="setWinner"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </tab-layout>
</template>

<script>
import { defineComponent, getCurrentInstance } from '@vue/composition-api'
import TabLayout from '@/components/TabLayout'
import PageHeading from '@/components/PageHeading'
import PrizesResultsTable from '@/components/Prizes/PrizesResultsTable'
import PrizesCutoutsTable from '@/components/Prizes/PrizesCutoutsTable'
import usePrizesView from '@/composables/prizes/usePrizesView'

export default defineComponent({
  name: 'PrizesView',
  components: { TabLayout, PageHeading, PrizesResultsTable, PrizesCutoutsTable },
  setup() {
    const { proxy } = getCurrentInstance()
    const eventId = proxy.$route.params.eventId

    const {
      rounds,
      activeRound,
      activeRoundData,
      cutouts,
      eventName,
      loading,
      downloadingPdf,
      fetchPrizes,
      setWinner,
      downloadPdf
    } = usePrizesView(eventId)

    fetchPrizes()

    return {
      rounds,
      activeRound,
      activeRoundData,
      cutouts,
      eventName,
      loading,
      downloadingPdf,
      setWinner,
      downloadPdf
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/views/Prizes/PrizesView.vue